module.exports = __webpack_public_path__ + "ec7234065d7da666d13ffcf8890085d6.MP3";